import loadingExample from "../../../../src/content/guidelines/copy/ux-writing-principles/loading-state.png";
import errorExample from "../../../../src/content/guidelines/copy/ux-writing-principles/oh-snap.png";
import inputExample from "../../../../src/content/guidelines/copy/ux-writing-principles/input-info.png";
import * as React from 'react';
export default {
  loadingExample,
  errorExample,
  inputExample,
  React
};